import { jwtDecode } from 'jwt-decode';
 // You need to install this library: `npm install jwt-decode`
 import api from "../../src/utils/api";

// Function to log in a user by making a POST request to the API

export const loginUser = async (username, password) => {
  try {
    const response = await api.post("/authenticate", { username, password });
    const data = response.data;

    localStorage.setItem('authToken', data.token);
    localStorage.setItem('username', username);
    localStorage.setItem('firstName', data.firstName);
    localStorage.setItem('lastName', data.lastName);
    localStorage.setItem('roles', JSON.stringify(data.roles));
    localStorage.setItem('userId', data.userId);
    localStorage.setItem('roleId', data.roleId);


    return data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'An error occurred during login.');
  }
};

// Function to check if the user is authenticated by checking the token and its expiration
export const checkAuthentication = () => {
  const authToken = localStorage.getItem('authToken');

  if (!authToken) {
    window.location.href = '/login'; // Redirect to login page if not authenticated
    return;
  }

  // Decode the token to check its expiration
  const decodedToken = jwtDecode(authToken);
  const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds

  if (decodedToken.exp < currentTime) {
    signOut(); // Sign out if token is expired
    alert('Session expired. Please log in again.');
  }
};

// Function to check if the user has the required roles to access a feature
export const checkRole = (requiredRoles) => {
  const roles = JSON.parse(localStorage.getItem('roles') || '[]');

  // Check if any of the user's roles match the required roles
  const hasAccess = roles.some((role) => requiredRoles.includes(role));

  if (!hasAccess) {
    window.location.href = '/unauthorized'; // Redirect to an unauthorized page
  }
};

// Function to sign out the user by clearing localStorage and redirecting to login
export const signOut = () => {
  // Clear all relevant data from localStorage
  localStorage.removeItem('authToken');
  localStorage.removeItem('username');
  localStorage.removeItem('firstName');
  localStorage.removeItem('lastName');
  localStorage.removeItem('roles');
  localStorage.removeItem('userId');

  // Clear session storage if used
  sessionStorage.clear();

  // Clear cookies if necessary
  document.cookie = 'username=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  document.cookie = 'authToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';

  // Redirect to the login page
  window.location.href = '/login';
};
